import { IRequesterInfo } from '../../../../../base/models'
import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IBankModelList } from '../models/models'

export class GetBanksApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/dealerPaymentOperation/getBankList',
      requesterInfo,
    })
  }

  public async listAllBanks(): Promise<IBankModelList[]> {
    return await this.getAsync<IBankModelList[]>()
  }
}
